import React from "react"
import { makeStyles } from "makeStyles"
import { SeriesModel } from "utils/commerceTools/formatters/formatSeries"
import Button from "components/Buttons/Button"

import { BiPrinter } from "react-icons/bi"

const createNewWindow = () => window.open("/sheet", "", "width: 500, height=500,scrollbars=yes")

const openPrintPopUp = (title: string, content: string) => {
	const popup = createNewWindow()
	if (popup) {
		popup.document.write(content)
		popup.document.title = title
	}
}

const getContent = (
	model: SeriesModel,
	models: SeriesModel[],
	shortDescription: string,
	atAGlanceContent: string,
) => {
	const {
		name,
		images,
		attributes: {
			securityGrade,
			fireSafetyGrade,
			volumeLiter,
			weightKg,
			innerDepth,
			innerHeight,
			innerWidth,
			outerDepth,
			outerHeight,
			outerWidth,
			numberOfA4Folders,
			numberOfKeyHooks,
			numberOfShelves,
			numberOfWeaponFixtures,
			doorSwingDirection,
			doorOpeningAngle,
			positionOfHinges,
			anchoring,
		},
	} = model

	const modelsNames = models.map((model) => model.name.replace(/^Secureo\s(\w+)?\s/, ""))

	const image = images?.[0]

	const innerDimensions =
		innerWidth && innerHeight && innerDepth
			? `B${innerWidth.toLocaleString()} x H${innerHeight.toLocaleString()} x T${innerDepth.toLocaleString()}cm`
			: ""
	const outerDimensions =
		outerWidth && outerHeight && outerDepth
			? `B${outerWidth.toLocaleString()} x H${outerHeight.toLocaleString()} x T${outerDepth.toLocaleString()}cm`
			: ""
	return `
<!DOCTYPE html>
<html lang="en">
	<head>
		<meta charset="UTF-8" />
		<meta http-equiv="X-UA-Compatible" content="IE=edge" />
		<meta name="viewport" content="width=device-width, initial-scale=1.0" />
		<title>Document</title>
		<style>
			@import url("https://fonts.googleapis.com/css2?family=Bitter:wght@700&family=Open+Sans&display=swap");

			:root {
				--col-padding-x: 5mm;
				--col-padding-y: 3mm;

				/* Colors */
				--dark-grey: #182f37;
				--light-grey: #eef0f0;
				--turquoise: #009cac;
				--white: rgba(255, 255, 255, 0.9);
			}
			html,
			body {
				height: 297mm;
				max-height: 297mm;
				width: 210mm;
				padding: 0;
				margin: 0;
				font-family: "Open Sans", sans-serif;
			}
			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				font-family: "Bitter", serif;
				letter-spacing: 0.2mm;
			}
			header,
			footer {
				height: 50mm;
				background-color: var(--dark-grey);
				color: var(--white);
			}

			header > svg {
				margin-top: 10mm;
				margin-left: 6mm;
			}

			main {
				height: 100%;
				display: flex;
				justify-content: space-between;
				padding: 0 6mm;
			}

			footer {
				height: 40mm;
				display: flex;
				justify-content: space-between;
				background-color: var(--dark-grey);
				color: var(--white);
				padding: 0 10mm;
			}

			footer > div {
				align-self: flex-end;
				margin-bottom: 30px;
			}

			footer > .footer-right-col {
				position: relative;
			}

			.left-col {
				width: 53%;
			}
			.product-description {
				background: #fff;
				margin: -10mm 0 5mm;
				border-radius: 5px;
				border: 1px solid var(--turquoise);
				padding: 10mm;
			}
			.product-data {
				padding: 10mm 7mm;
				background-color: var(--light-grey);
				border-radius: 5px;
			}
			table {
				text-align: left;
				line-height: 2;
			}
			table > tbody > tr > th {
				min-width: 40mm;
				font-weight: 500;
			}
			table > tbody > tr > td {
				font-weight: 700;
			}

			.right-col {
				width: 44%;
				margin-top: -20mm;
				height: 50mm;
			}

			.right-col img {
				display: block;
				margin: 20mm 0mm 0mm 0mm;
				height: 90mm;
				object-fit: contain;
				width: 100%;
			}
			.models,
			.at-a-glance {
				margin-top: 0px;
			}
			ul {
				padding-left: 4mm;
				
			}
			ul > li {
				margin-bottom: 8px;
				list-style: square;
				font-size: 0.9rem;
			}

			.consult {
				background: var(--turquoise);
				padding: 2mm 0mm 1mm 5mm;
				border-radius: 5px;
			}
			.consult .info-text {
				margin-bottom: 0;
				margin-left: 8mm;
				color: #fff;
				text-transform: uppercase;
			}

			footer > .footer-right-col > .consult {
				position: absolute;
				top: -105px;
				left: 0;
				width: 100%;
			}
		</style>
	</head>
	<body>
		<header class="header">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 100">
				<defs>
					<style>
						.logo_svg__a {
							fill: #fff;
						}
					</style>
				</defs>
				<path
					class="logo_svg__a"
					d="M44.196 16.539a8.737 8.737 0 00-4.6-2.562q-.529-.6-1.1-1.164a22.092 22.092 0 00-1.745-1.544 22.04 22.04 0 00-3.93-2.486 21.547 21.547 0 00-4.36-1.593 21.059 21.059 0 00-9.191-.133h.029a15.631 15.631 0 00-7.859 4.208l-.139.137c-.09.092-.18.184-.269.278l-.131.141q-.2.214-.384.431l-.125.146c-.082.1-.162.2-.242.3s-.157.2-.234.3-.153.2-.226.307a16.52 16.52 0 00-.43.626 16.18 16.18 0 00-.523.868l-.15.271q-.278.519-.515 1.056c.042-.13.086-.259.13-.389.223-.636.468-1.261.742-1.875a23.242 23.242 0 011.953-3.517l.01-.014.489-.694.006-.009c.15-.2.3-.4.45-.594.079-.1.155-.2.235-.3l.242-.291c.158-.195.326-.383.5-.571.084-.093.165-.189.253-.281l.262-.272c.175-.181.348-.365.526-.542a22.469 22.469 0 011.665-1.485l.03-.024a23.312 23.312 0 016.484-3.695A23.393 23.393 0 0125.673.537l.465-.089L26.6.37a22.33 22.33 0 018.191 3.276c.1.063.2.13.294.2l.436.3c.1.068.189.136.282.206q.572.418 1.115.873c.112.093.224.188.335.284a22.628 22.628 0 013.806 4.263c.083.122.165.243.246.367s.162.246.241.372.156.25.232.375q.171.286.335.574a22.332 22.332 0 011.793 4.081c.016.048.031.1.046.143s.029.094.044.14q.08.256.154.516c.013.069.032.132.046.199zM33.348 37.16z"
				></path>
				<path
					class="logo_svg__a"
					d="M33.734 11.439a15.731 15.731 0 00-4.966-3.416 23.183 23.183 0 013.669 1.521c.663.344 1.31.717 1.937 1.125a23.151 23.151 0 013.5 2.779q.188.179.37.363a8.897 8.897 0 00-.4-.009 8.805 8.805 0 00-2.037.237 16.61 16.61 0 00-.358-.535l-.109-.156c-.075-.1-.149-.206-.226-.308q-.46-.612-.982-1.182-.13-.141-.264-.283zM44.164 28.592a44.092 44.092 0 01-.3.986c-.059.178-.121.355-.183.533s-.13.351-.2.525a21.308 21.308 0 01-1.117 2.434c-.1.2-.211.39-.322.583a18.335 18.335 0 01-.339.571c-.042.068-.076.126-.116.188s-.069.109-.1.165a36.1 36.1 0 01-.356.538l-.072.107a14.785 14.785 0 01-.334.473l-.23.311c-.077.103-.155.205-.234.307s-.16.2-.239.3-.163.2-.246.3c-.047.056-.094.112-.143.168s-.081.1-.122.143q-.082.1-.165.19l-.3.327q-.3.323-.609.636l-.156.156-.178.172-.095.091-.134.128-.153.141c-.046.042-.09.083-.137.124a.572.572 0 01-.047.043l-.225.2c-.056.05-.111.1-.167.145s-.112.1-.167.142l-.019.016-.013.01-.108.09a.275.275 0 01-.031.025l-.17.14-.173.138c-.231.181-.464.36-.7.534q-.09.067-.18.13-.179.129-.361.254a21.254 21.254 0 01-.738.486l-.189.118c-.125.077-.251.154-.378.229a22.352 22.352 0 01-8.231 2.887 22.687 22.687 0 01-5.991.051c.609-.08 1.212-.2 1.812-.332.164-.035.326-.076.488-.116l.244-.061.242-.067c.162-.044.324-.09.483-.141s.322-.1.48-.152a21.367 21.367 0 003.688-1.622l.221-.124.217-.127a20.748 20.748 0 001.279-.812l.206-.143.208-.148.4-.3c.134-.1.271-.2.4-.306l.2-.157.2-.163.014-.012.012-.01.024-.02.048-.041.1-.081.194-.167.189-.167.192-.174c.124-.113.25-.229.373-.348s.244-.234.365-.355c.235-.247.472-.491.7-.742.114-.126.228-.251.34-.381l.165-.193.165-.2a23.792 23.792 0 001.288-1.724c.201-.3.394-.6.577-.907.094-.154.183-.31.272-.462l.132-.235.127-.238.126-.237c.042-.079.083-.158.121-.24l.233-.483c.078-.162.157-.321.229-.485l.206-.5.176-.424a8.988 8.988 0 001.011.059 8.72 8.72 0 006.321-2.697zM7.533 31.899l.175.169.179.162c.12.108.244.214.367.322.123.1.245.209.368.309l.375.3c.249.2.508.392.765.584.521.374 1.052.734 1.6 1.064.135.087.276.165.414.246s.277.164.418.239l.424.23.43.218c.575.288 1.161.556 1.76.793.3.125.6.229.9.345s.61.213.92.3c.155.046.308.1.464.141l.058.017a15.709 15.709 0 01-5.89-3.781l-.135-.138c-.09-.094-.178-.188-.264-.283l-.13-.144q-.193-.215-.377-.437l-.122-.148c-.081-.1-.16-.2-.238-.3s-.155-.2-.23-.306-.149-.205-.222-.31a16.55 16.55 0 01-.42-.634c-.034-.054-.068-.107-.1-.162-.065-.108-.13-.216-.193-.326l-.094-.163-.092-.167a18.421 18.421 0 01-.263-.5q-.085-.17-.165-.34a12.999 12.999 0 01-.156-.343 15.613 15.613 0 01-1.055-3.4 14.486 14.486 0 01-.328-1.73 20.336 20.336 0 01-.1-2.065 20.9 20.9 0 01.414-4.126 21.694 21.694 0 013.09-7.563v-.008l.075-.107.426-.619v-.011l.085-.112c.157-.21.31-.421.471-.627.082-.1.16-.208.243-.309l.25-.3c.164-.2.337-.4.514-.595.088-.1.174-.2.264-.291l.274-.282c.184-.187.364-.377.55-.562s.379-.361.574-.536c.387-.352.8-.686 1.2-1.011l.119-.1h.006a21.9 21.9 0 013.132-2.009q.857-.454 1.752-.827t1.817-.663a21.245 21.245 0 013.655-.8 22.465 22.465 0 00-2.826-.2 22.7 22.7 0 00-3.369.224 22.365 22.365 0 00-8.231 2.888c-.127.075-.253.152-.378.229l-.188.117-.372.24a19.53 19.53 0 00-.728.5l-.179.129c-.152.111-.3.224-.452.34-.084.064-.167.13-.25.2l-.172.138q-.257.208-.508.423l-.167.145q-.5.436-.967.9-.392.385-.766.791-.223.243-.44.492c-.048.055-.1.111-.144.167a21.093 21.093 0 00-.695.856q-.2.261-.4.529-.259.357-.505.725-.412.617-.784 1.263-.148.259-.291.521c-.11.205-.219.413-.324.621a22.35 22.35 0 00-2.006 6.011c.026.155.052.31.08.464v.007l.063.321v.04a.122.122 0 000-.025v.005a29.126 29.126 0 00.555 2.225c.056.182.116.364.174.547l.186.541c.13.356.26.709.4 1.061v.01l.111.265.018.044.093.223.015.036.038.086.021.045.008.017c0-.006-.007-.014-.011-.02l.016.034v-.008.012l.063.139.031.069.016.035v.005-.005l.036.093a.338.338 0 00-.016-.051v.012l.141.294c.049.1.1.2.151.3l.151.3c.046.094.1.187.147.28l.01.019c.066.119.129.239.2.358l.2.354a23.594 23.594 0 003.539 4.624zm-5.258-7.248v-.006s.003.012 0 .007zm0 .012z"
				></path>
				<path
					class="logo_svg__a"
					d="M36.116 31.12l-.116.248-.219.47c-.076.155-.161.307-.24.46l-.241.46c-.039.078-.082.152-.126.228l-.129.224-.13.225-.133.22c-.092.148-.182.3-.275.441a23.431 23.431 0 01-1.192 1.692c-.214.273-.429.542-.651.806l-.159.184-.161.188c-.106.122-.219.242-.328.363-.223.24-.453.473-.679.708a22.912 22.912 0 01-.708.68l-.178.163-.186.166-.341.3-.038.03-.178.148-.188.156c-.126.1-.256.2-.383.3l-.385.3-.194.143-.2.141c-.266.191-.531.371-.8.551-.135.09-.269.173-.409.261l-.208.129-.209.124q-.836.5-1.714.926a22.368 22.368 0 01-2.708 1.117l-.231.08-.233.075c-.156.05-.311.1-.468.145-.627.187-1.263.342-1.9.482-.321.064-.643.131-.968.184h-.024a22.369 22.369 0 01-9.532-4.178q-.314-.237-.617-.482l-.153-.126c-.088-.071-.175-.146-.262-.218-.112-.094-.222-.191-.333-.287-.08-.072-.16-.144-.241-.219q-.45-.409-.877-.843a22.824 22.824 0 01-2.522-3.055c-.083-.123-.165-.244-.246-.367s-.161-.247-.24-.372q-.148-.234-.29-.471a32.92 32.92 0 01-.278-.478q-.136-.242-.266-.487l-.128-.245-.126-.247c-.1-.2-.2-.4-.291-.6l-.081-.178c-.026-.058-.054-.118-.079-.177l-.015-.033a.023.023 0 010-.008.12.12 0 01-.006-.014l-.09-.21c-.008-.019-.017-.038-.024-.058a.065.065 0 010-.011c-.012-.025-.023-.054-.035-.082l-.03-.07a.07.07 0 00-.005-.012c0-.014-.01-.026-.014-.038-.024-.062-.049-.121-.074-.182-.048-.121-.1-.242-.142-.364-.053-.141-.1-.281-.155-.421q-.113-.318-.218-.638a20.857 20.857 0 01-.322-1.082l-.058-.22c-.038-.146-.073-.293-.109-.439l-.052-.223c-.05-.223-.1-.445-.141-.668-.019-.094-.036-.188-.053-.282a18.943 18.943 0 01-.041-.233l-.008-.049c0-.016-.006-.032-.008-.049l-.015-.092c0-.027-.009-.053-.012-.08a.03.03 0 010-.007c0-.017-.006-.036-.009-.054s0-.022 0-.031 0-.027-.006-.041a14.373 14.373 0 01-.078-.569 22.791 22.791 0 010-5.681c.037.279.078.556.13.83.063.388.147.769.233 1.152.046.191.094.38.141.569s.1.379.156.568c.114.375.231.749.36 1.115a.016.016 0 000 .005l.1.282c.034.094.069.185.1.276l.081.214v.01l.058.142.03.072.015.036.007.019.007.015v.007l.07.167.069.159c.045.107.095.212.143.318l.148.318c.049.105.1.208.151.313l.022.046c.055.109.11.22.169.329l.2.373c.325.593.675 1.166 1.049 1.728s.78 1.1 1.207 1.624.879 1.025 1.351 1.505l.73.7.183.174.189.17c.126.111.253.22.38.328l.008.008c.126.106.251.209.382.315l.395.306c.26.207.534.4.8.594.136.094.276.187.414.279l.208.14.211.132c.142.087.281.179.424.263l.43.253a21.482 21.482 0 003.63 1.639c.156.055.313.109.473.157l.475.148c.32.085.638.18.961.252a20.729 20.729 0 003.915.557q.9.042 1.805 0h.365a15.648 15.648 0 0010.985-4.53l.138-.137c.091-.092.18-.184.269-.278q.532-.562 1-1.166c.078-.1.154-.2.23-.3l.112-.155c.149-.207.292-.415.43-.627l.019-.029c.114.017.234.042.354.068z"
				></path>
				<g>
					<path
						class="logo_svg__a"
						d="M73.635 15.704v7.621q0 3.292-3.1 3.3t-3.109-3.3v-7.621h-3.169v7.685a6.906 6.906 0 00.419 2.754 4.718 4.718 0 001.481 1.866 7.73 7.73 0 008.736 0 4.634 4.634 0 001.481-1.866 7.829 7.829 0 00.434-2.754v-7.685zM18.933 28.961a8.054 8.054 0 01-2.468-1.075l1.2-2.384a7.634 7.634 0 002.167.987 9 9 0 002.468.36q2.806 0 2.8-1.48a.986.986 0 00-.711-.987 12.374 12.374 0 00-2.3-.528 18.128 18.128 0 01-2.69-.573 4.131 4.131 0 01-1.806-1.14 3.192 3.192 0 01-.765-2.271 3.566 3.566 0 011.594-3.044 7.212 7.212 0 014.294-1.141 12.522 12.522 0 012.759.316 7.642 7.642 0 012.251.839l-1.2 2.379a7.43 7.43 0 00-3.835-.987 4.254 4.254 0 00-2.093.415 1.234 1.234 0 00-.711 1.091 1.08 1.08 0 00.76 1.061 11.894 11.894 0 002.369.592 18.455 18.455 0 012.626.558 4.12 4.12 0 011.767 1.1 3.077 3.077 0 01.74 2.207 3.5 3.5 0 01-1.629 3.006 7.707 7.707 0 01-4.442 1.125 12.028 12.028 0 01-3.145-.426zM44.362 23.522h-10.5a3.647 3.647 0 001.441 2.344 4.712 4.712 0 002.892.864 4.884 4.884 0 003.633-1.451l1.678 1.93a5.661 5.661 0 01-2.28 1.624 9.013 9.013 0 01-6.989-.326 6.279 6.279 0 01-2.591-2.438 6.907 6.907 0 01-.913-3.548 7.007 7.007 0 01.888-3.519 6.306 6.306 0 012.468-2.443 7.212 7.212 0 013.554-.879 7.027 7.027 0 013.5.884 6.115 6.115 0 012.4 2.428 7.366 7.366 0 01.864 3.608 7.054 7.054 0 01-.045.922zm-9.259-4.442a3.736 3.736 0 00-1.264 2.369h7.611a3.663 3.663 0 00-3.786-3.257 3.779 3.779 0 00-2.562.883zM50.773 28.507a6.411 6.411 0 01-2.576-2.438 6.8 6.8 0 01-.928-3.548 6.709 6.709 0 01.928-3.529 6.492 6.492 0 012.567-2.434 7.838 7.838 0 013.746-.878 7.249 7.249 0 013.455.8 5.186 5.186 0 012.241 2.306l-2.4 1.4a3.844 3.844 0 00-1.441-1.393 4.215 4.215 0 00-4.8.682 4.608 4.608 0 00-.015 6.085 4.225 4.225 0 004.813.676 3.808 3.808 0 001.441-1.391l2.4 1.407a5.427 5.427 0 01-2.265 2.314 7.078 7.078 0 01-3.455.814 7.837 7.837 0 01-3.711-.873zM89.232 15.689v2.961a4.02 4.02 0 00-.725-.074 3.786 3.786 0 00-2.858 1.066 4.245 4.245 0 00-1.027 3.07v6.5h-3.129V15.836h2.961v1.975q1.368-2.127 4.778-2.122zM105.491 23.523H94.998a3.639 3.639 0 001.436 2.344 4.728 4.728 0 002.9.864 4.88 4.88 0 003.633-1.452l1.678 1.93a5.666 5.666 0 01-2.28 1.624 9.013 9.013 0 01-6.989-.326 6.319 6.319 0 01-2.591-2.438 6.907 6.907 0 01-.913-3.548 7.007 7.007 0 01.888-3.52 6.347 6.347 0 012.468-2.443 7.237 7.237 0 013.559-.879 7.016 7.016 0 013.49.884 6.084 6.084 0 012.4 2.428 7.374 7.374 0 01.869 3.623c-.002.202-.022.508-.055.909zm-9.254-4.442a3.716 3.716 0 00-1.263 2.369h7.591a3.661 3.661 0 00-3.786-3.257 3.775 3.775 0 00-2.542.883zM111.856 28.507a6.369 6.369 0 01-2.542-2.438 6.911 6.911 0 01-.917-3.549 6.791 6.791 0 01.917-3.529 6.425 6.425 0 012.542-2.429 8.106 8.106 0 017.339 0 6.414 6.414 0 012.542 2.434 6.789 6.789 0 01.918 3.528 6.906 6.906 0 01-.918 3.548 6.352 6.352 0 01-2.542 2.438 8.1 8.1 0 01-7.339 0zm6.515-2.962a4.642 4.642 0 000-6.061 3.824 3.824 0 00-2.857-1.15 3.764 3.764 0 00-2.843 1.15 4.65 4.65 0 00-.02 6.066 3.772 3.772 0 002.843 1.155 3.835 3.835 0 002.877-1.155z"
					></path>
				</g>
			</svg>
		</header>

		<main>
			<div class="left-col">
				<div class="product-description">
					<h1 style="font-size: 26px">${name}</h1>
					<p>
						${shortDescription}
					</p>
				</div>
				<div class="product-data">
					<h2>Produktdaten</h2>
					<table>
						<tbody>
							<tr>
								<th>Sicherheitsstufe</th>
								<td>${securityGrade}</td>
							</tr>
							<tr>
								<th>Brandschutz</th>
								<td>${fireSafetyGrade}</td>
							</tr>
							<tr>
								<th>Gewicht</th>
								<td>${weightKg} kg</td>
							</tr>
							<tr>
								<th>Volumen</th>
								<td>${volumeLiter} l</td>
							</tr>
							${
								outerDimensions
									? `<tr>
								<th>Außenmaße</th>
								<td>${outerDimensions}</td>
							</tr>`
									: ""
							}
							${
								innerDimensions
									? `<tr>
								<th>Innenmaße</th>
								<td>${innerDimensions}</td>
							</tr>`
									: ""
							}
							${
								numberOfShelves
									? `<tr>
								<th>Anz. Fachböden</th>
								<td>${numberOfShelves}</td>
							</tr>`
									: ""
							}
							${
								numberOfKeyHooks
									? `<tr>
								<th>Anz. Schlüsselhaken</th>
								<td>${numberOfKeyHooks}</td>
							</tr>`
									: ""
							}
							${
								doorSwingDirection
									? `<tr>
								<th>Türanschlag</th>
								<td>${doorSwingDirection?.replace("right", "rechts")?.replace("left", "links")}</td>
							</tr>`
									: ""
							}
							${
								doorOpeningAngle
									? `<tr>
								<th>Türöffnungswinkel</th>
								<td>${doorOpeningAngle}</td>
							</tr>`
									: ""
							}
							${
								anchoring
									? `<tr>
								<th>Verankerung</th>
								<td>${anchoring}</td>
							</tr>`
									: ""
							}
							${
								positionOfHinges
									? `<tr>
								<th>Scharniere</th>
								<td>${positionOfHinges?.replace("inside", "innen")?.replace("outside", "aussen")}</td>
							</tr>`
									: ""
							}
						</tbody>
					</table>
				</div>
			</div>

			<div class="right-col">
				<img src="${image}" alt="Produkt" />
				${
					modelsNames.length > 1
						? `<div class="models">
					<h2>Modelle dieser Serie</h2>
					<p>${modelsNames.reduce((acc, name) => acc + ", " + name)}</p>
				</div>`
						: ""
				}
				<div class="at-a-glance">
					${atAGlanceContent}
				</div>
			</div>
		</main>

		<footer>
			<div>
				<p>
					<span style="font-size: 1.2rem">Erhätllich</span> bei <br />tresoro.de,
					tresoro.at, safehero.com und Amazon
				</p>
			</div>
			<div class="footer-right-col">
				<div class="consult">
					
						<p class="info-text">
							<strong>Kostenlose Beratung</strong>
						</p>
						<h3 style="margin-top: 0; margin-left: 8mm; color: #000000">+43 512 932791</h3>
				</div>
				<p>
					<span style="font-size: 1.2rem">Secureo GmbH</span> <br />www.secureo.at,
					office@secureo.at
				</p>
			</div>
		</footer>
	</body>
</html>
`
}

const useStyles = makeStyles()(() => ({
	root: {
		maxWidth: 200,
		marginTop: 15,
		marginBottom: 30,
		"@media only screen and (max-width: 960px)": {
			marginBottom: 50,
		},
	},
}))

const PrintProductSheet = ({ model, models, shortDescription, atAGlanceContent }: Props) => {
	const { classes } = useStyles()
	const { name } = model

	const onClick = () => {
		const content = getContent(model, models, shortDescription, atAGlanceContent)
		openPrintPopUp(name, content)
	}

	return (
		<Button
			onClick={onClick}
			color="primary"
			className={classes.root}
			style={{
				color: "#fff",
				textTransform: "inherit",
				border: "1px solid grey",
				padding: "5px 20px",
				background: "rgba(255, 255, 255, 0.05)",
			}}
		>
			<BiPrinter size="1.2rem" style={{ marginRight: 8 }} />
			Drucken
		</Button>
	)
}

interface Props {
	model: SeriesModel
	models: SeriesModel[]
	shortDescription: string
	atAGlanceContent: string
}

export default PrintProductSheet
